import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Loading from '../Share/Loading/Loading';
import CatagorieChart from './catagorieChart/CatagorieChart';

const Catagories = () => {
    const { data: catagories = [], isLoading, refetch } = useQuery({
        queryKey: ['catagories'],
        queryFn: async () => {
            const res = await fetch('https://assignment-12-server-beige.vercel.app/catagories')
            const data = await res.json();
            return data;
        }
    })

    if (isLoading) {
        return <Loading></Loading>
    }

    return (
        <div className='mt-12'>
            <h1 className='text-4xl font-bold text-center mt-8'>BOOK CATAGORY</h1>
            <p className='text-center mt-2'>We provide Excellent
                Books Selling and Buying service.</p>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 my-6 '>
                {
                    catagories.map(catagory => <CatagorieChart catagory={catagory}></CatagorieChart>)
                }
            </div>
        </div>
    );
};

export default Catagories;